const jump = {
  /**
   * 获得跳转目标
   * @param id
   * @returns {*}
   */
  getJumpTargetId (id) {
    let jumpTargetId = null
    let question = this.indexes[id].data
    let answer = this.indexes[id].answer
    // 第二序列跳转目标
    if (question.jumpTargetId) {
      jumpTargetId = question.jumpTargetId
    }
    // 第一序列跳转目标
    if (this.isChoice(question.id)) {
      // 答案未选择任何一个选项。出现在订单未提交，还未获得答案时
      if (!answer.selectedOptionId.length) {
        jumpTargetId = ''
      } else {
        // 使用问题选项列表中，第一个被选中选项的跳转设置(服务于多选)
        for (let index = 0; index < question.options.length; index++) {
          const option = question.options[index]
          // 得到被选中的跳转设置，终止遍历
          if (answer.selectedOptionId.includes(option.id)) {
            // 存在跳转设置
            if (option.jumpTargetId) {
              // 获得选项的跳转目标
              jumpTargetId = option.jumpTargetId
            }
            break
          }
        }
      }
    }
    return jumpTargetId
  },

  /**
   * 是否跳过
   * @param {string} id
   */
  isJumped (id) {
    return this.indexes[id].isJumped
  }

}

export default jump



// WEBPACK FOOTER //
// ./src/views/question-review/review/jump.js